import { render, staticRenderFns } from "./CustomerListPage.vue?vue&type=template&id=d3d6e5ca&"
import script from "./CustomerListPage.vue?vue&type=script&lang=ts&"
export * from "./CustomerListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports